export const ORDER_TYPE = {
  SHIPMENT: 'shipment',
  PURCHASE: 'purchase'
}
